"use client";
/*
 * Documentation:
 * DC_Card_Tabs — https://app.subframe.com/4f62853ee923/library?component=DC_Card_Tabs_8f10f950-a27c-4e27-813f-0308659ff498
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface Dc_Card_TabsRootProps extends React.HTMLAttributes<HTMLDivElement> {
  tabs?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const Dc_Card_TabsRoot = React.forwardRef<
  HTMLDivElement,
  Dc_Card_TabsRootProps
>(function Dc_Card_TabsRoot(
  { tabs, children, className, ...otherProps }: Dc_Card_TabsRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex flex-col items-start gap-6 rounded-md bg-neutral-50 px-6 py-6",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      {tabs ? (
        <div className="flex flex-col items-start gap-6">{tabs}</div>
      ) : null}
      {children ? (
        <div className="flex flex-col items-start gap-6">{children}</div>
      ) : null}
    </div>
  );
});

export const Dc_Card_Tabs = Dc_Card_TabsRoot;
